import React from 'react';


export const TableCashFlow = (props) => {
    const { headers, values } = props;

    return (
        <table style={{ width: '100%' }}>

            <thead>
                {props.extraHeaderRow && (
                    <tr>
                        {props.extraHeaderRowColSpan.map(e => {
                            const rowStyle = {
                                textAlign: 'center !important',
                                verticalAlign: 'middle',
                                padding: '10px 0 !important',
                                fontSize: '12px',
                                backgroundColor: 'rgba(213, 251, 243, 1)',
                                ...props.rowStyle
                            }
                            return <th colSpan={e.col} style={rowStyle}> {e.title} </th>
                        }
                        )}
                    </tr>
                )}
                <tr>
                    {headers.map(header => header)}
                </tr>
            </thead>
            <tbody>
                {values.map(row => row)}
            </tbody>
        </table>
    )
}